import { createSiteAllowlistFlag } from "@/utils/siteAllowlistFlag";

// Rollout flags never bypass the separate staff-access gate.
export const isDimensionsDeliverabilityEnabledForSite = createSiteAllowlistFlag(
  import.meta.env.VITE_FF_ENABLE_DIMENSIONS_DELIVERABILITY,
  import.meta.env.VITE_FF_DIMENSIONS_DELIVERABILITY_SITES,
);
